module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-MediumOblique.141218a4.woff";